(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('VisitCommentRepository', [
        'AprimaAnalytics',
        'AprimaRestangular',
        VisitCommentRepository
    ]);

    function VisitCommentRepository(
        AprimaAnalytics,
        AprimaRestangular
    ) {
        return {
            getVisitComment : getVisitComment,
            updateVisitComment : updateVisitComment,
        };

        function getVisitComment(visitId, visitCommentType) {
            var timing = AprimaAnalytics.startTiming('VisitCommentRepository', 'api', 'getContext');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('visitcomment/' + visitId )
                .get({ 'visitComment' : visitCommentType})
                .finally(timing.stop);
        }

        function updateVisitComment(visitCommentTypeDto) {
            var timing = AprimaAnalytics.startTiming('VisitCommentRepository', 'api', 'getContext');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('visitcomment/update/')
                .customPOST(visitCommentTypeDto)
                .finally(timing.stop);
        }
    }
})();